// extracted by mini-css-extract-plugin
module.exports = {"legend":"Fieldset_legend__UeHkn"};